import { alpha, Box, Button } from "@mui/material";
import { Close, Pause, PlayArrow, RestartAlt, RestartAltRounded, Stop } from "@mui/icons-material";
import React, { useContext, useEffect, useState } from "react";
import { TestContext } from "../../context/test_context";
import LoadBox from "../global/LoadBox";
import { TestListContext, TestPageContext } from "../../scenes/tests";
import { wait } from "@testing-library/user-event/dist/utils";
import { LoadingButton } from "@mui/lab";
import { grey } from "@mui/material/colors";
import { tokens, useMode } from "../../theme";
import { toast } from "react-toastify";

export type TestControlButtonsType = {
  testgroup: any,
  testgroup_index: any
}

export default function TestsControlButtons({ testgroup, testgroup_index }: TestControlButtonsType) {
  // const {reload, setReload} = useContext(TestPageContext)
  const {
    deleteTestGroup,
    pauseTestGroup,
    restartTestGroup,
    stopTestGroup,
    pauseLoading,
    restartLoading,
    stopLoading,
    deleteLoading
  } = React.useContext(TestContext);
  const { testgroups, setTestGroups } = useContext(TestListContext);
  const { reload, setReload } = useContext(TestPageContext);
  const [theme, colorMode] = useMode();
  const colors = tokens(theme.palette.mode);

  const buttonStyle = {
    width: 100,
    mr: 1
    // my: { xs: 0, sm: 1, md: 0 },
    // backgroundColor: "#ff5757",
    // backgroundColor: colors.background,
    // boxShadow: `1px 1px 5px 0px ${alpha("#000000", 0.5)}`,
  };
  const test_data = testgroup;

  useEffect(() => {
  }, [testgroups]);

  async function togglePlayPause(test_data: any) {
    if (!test_data || !test_data.id) {
      console.error("Cannot pause test: test_data or test_data.id is undefined");
      return;
    }
    console.log(`Paused: ${test_data.id} with ${test_data.active}`);
    const resp = await pauseTestGroup(test_data.id);
    if (resp && resp.success) {
      setTestGroups((prevTestGroups: any) =>
        prevTestGroups.map((group: any, index: number) =>
          index === testgroup_index ? resp.testgroup : group
        ));
      setReload(!reload);
    } else {
      alert("Action not successful");
    }
  };

  async function toggleStop(test_data: any) {
    if (!test_data || !test_data.id) {
      console.error("Cannot stop test: test_data or test_data.id is undefined");
      return;
    }
    console.log(`Stopped: ${test_data.id} with ${test_data.finished}`);
    const resp = await stopTestGroup(test_data.id);
    if (resp && resp.success) {
      setTestGroups((prevTestGroups: any) =>
        prevTestGroups.map((group: any, index: number) =>
          index === testgroup_index ? resp.testgroup : group
        ));
      setReload(!reload);
    } else {
      alert("Action not successful");
    }
  };

  async function toggleRestart(test_data: any) {
    if (!test_data || !test_data.id) {
      console.error("Cannot restart test: test_data or test_data.id is undefined");
      return;
    }
    console.log(`Restarted: ${test_data.id} with ${test_data.finished}`);
    const resp = await restartTestGroup(test_data.id);
    if (resp && resp.success) {
      setTestGroups((prevTestGroups: any) =>
        prevTestGroups.map((group: any, index: number) =>
          index === testgroup_index ? resp.testgroup : group
        ));
      setReload(!reload);
    } else {
      alert("Action not successful");
    }
  };

  async function toggleDelete(test_data: any) {
    if (!test_data || !test_data.id) {
      console.error("Cannot delete test: test_data or test_data.id is undefined");
      return;
    }
    console.log(`Deleted: ${test_data.id} with ${test_data.finished}`);
    const resp = await deleteTestGroup(test_data.id);
    if (resp && resp.success) {
      // Remove the test from the list
      setTestGroups((prevTestGroups: any) =>
        prevTestGroups.filter((group: any, index: number) =>
          index !== testgroup_index
        ));
      setReload(!reload);
    } else {
      alert("Action not successful");
    }
  };


  // If test_data is undefined, don't render anything
  if (!test_data) {
    console.error("Cannot render TestsControlButtons: test_data is undefined");
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        // flexDirection: { xs: "row", sm: "column", md: "row" },
        flexDirection: "row",
        alignContent: "center",
        alignItems: "center"
      }}
    >
      {!test_data.finished ?
        <LoadingButton
          loading={pauseLoading}
          sx={buttonStyle}
          size={"medium"}
          variant="contained"
          onClick={() => {
            toast.promise(
              togglePlayPause(test_data).then(() => {
              }),
              {
                pending: test_data.active ? "Pausing Test..." : "Resuming Test...",
                success: test_data.active ? "Paused Test" : "Resumed Test",
                error: test_data.active ? "Error Pausing Test" : "Error Resuming Test"
              }
            );
          }}
          // onClick={() => togglePlayPause(test_data)}
          startIcon={test_data.active ? <Pause /> : <PlayArrow />}
        >
          {test_data.active ? "Pause" : "Play"}
        </LoadingButton> : <LoadingButton
          loading={restartLoading}
          sx={buttonStyle}
          size={"medium"}
          variant="contained"
          onClick={() => {
            toast.promise(
              toggleRestart(test_data).then(() => {
              }),
              {
                pending: "Restarting Test...",
                success: "Restarted Test",
                error: "Error Restarting Test"
              }
            );
          }}
          // onClick={() => toggleRestart(test_data)}
          startIcon={<RestartAlt />}
        >
          Restart
        </LoadingButton>}
      {!test_data.finished &&
        <LoadingButton
          loading={stopLoading}
          sx={buttonStyle}
          size={"medium"}
          variant="contained"
          onClick={() => {
            toast.promise(
              toggleStop(test_data).then(() => {
              }),
              {
                pending: "Stopping Test...",
                success: "Stopped Test",
                error: "Error Stopping Test"
              }
            );
          }}
          // onClick={() => toggleStop(test_data)}
          startIcon={<Stop />}
        >
          Stop
        </LoadingButton>}
      <Button
        sx={buttonStyle}
        size={"medium"}
        variant="contained"
        onClick={() => {
          if (
            window.confirm("Are you sure you want to delete this test group?")
          ) {
            toast.promise(
              toggleDelete(test_data).then(() => {
              }),
              {
                pending: "Deleting Test...",
                success: "Deleted Test",
                error: "Error Deleting Test"
              }
            );
          }
        }
        }
        startIcon={<Close />}
        // disabled={None}
      >
        Delete
      </Button>
    </Box>
  );
}
